import { render, staticRenderFns } from "./AssignAccountType.vue?vue&type=template&id=f7be0396"
import script from "./AssignAccountType.vue?vue&type=script&lang=js"
export * from "./AssignAccountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports